import Proxy from "./Proxy"

class AuthProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super("auth", parameters)
  }

  /**
   * Method used to login.
   *
   * @param {String} username The username.
   * @param {String} password The password.
   *
   * @returns {Promise} The result in a promise.
   */
  login({ username, password }) {
    const data = {
      username,
      password
      // client_id: process.env.VUE_APP_API_CLIENT_ID,
      // client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
      // grant_type: "password",
      // scope: ""
    }

    return this.submit("post", `${this.endpoint}/token/login`, data)
  }
}

export default AuthProxy
